/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  SubmittedAppService,
  ISubmittedAppMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  INotifyUserMethods,
  NotifyUserService,
} from './plugins';

export type SubmittedAppPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  ISubmittedAppMethods &
  INotifyUserMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new SubmittedAppService(),
    new NotifyUserService(),
  ];
};

export const getAgent = () => {
  return createAgent<SubmittedAppPageAgent>({
    plugins: getPlugins(),
  });
};
